export const application = {
  state: () => ({
    breadcrumb: [],
    searchQuery: "",
    // Autocomplete list for the header search, supplied by the current page.
    searchSuggestions: [],
    contactInfo: {
      street: "211 Ullamcorper St Roseville",
      email: "info@Below MSRP.com",
      phoneNo: "+1 712 345 678",
      socials: [
        { icon: "facebook-f", link: "/Below MSRP" },
        { icon: "twitter", link: "/Below MSRP" },
        { icon: "linkedin", link: "/Below MSRP" },
        { icon: "instagram", link: "/Below MSRP" },
      ],
    },
    settings: {
      websiteName: "Below MSRP",
    },
    locale: "en-US",
    currency: "USD",
    currentActiveModal: "",
  }),
  mutations: {
    setLocation(state, payload) {
      state.breadcrumb = payload;
    },
    setSearchQuery(state, payload) {
      state.searchQuery = payload || "";
    },
    setSearchSuggestions(state, payload) {
      state.searchSuggestions = Array.isArray(payload) ? payload : [];
    },
    toggleModal(state, payload) {
      if(state.currentActiveModal === payload) {
        state.currentActiveModal = ""
      } else {
      state.currentActiveModal = payload;
      }
    },
    forceCloseModal(state) {
      state.currentActiveModal = "";
    }
  },

  actions: {},
  getters: {
    modalIsQuickView: (state) => {
      return state.currentActiveModal.includes('qv');
    },
  },
};
